import React from 'react'
import './index.scss'
export default function NotAvailable() {
  return (
    <p className="not-available" style={{ margin: 'auto' }}>
      N/A
    </p>
  )
}
